interface FloatingBannerSettings {
    targetPages: string[]
    hideHours: number
}

declare global {
    interface Window {
        bishokuFloatingBanner?: FloatingBannerSettings
    }
}

const STORAGE_KEY = 'bishoku_fb_closed_at'

export function initFloatingBanner(): void {
    const settings = window.bishokuFloatingBanner
    if (!settings) return

    const banner = document.getElementById('js-floating-banner')
    if (!banner) return

    // 表示対象ページのチェック（前方一致）
    if (settings.targetPages.length > 0) {
        const currentPath = window.location.pathname
        const matched = settings.targetPages.some((page) =>
            currentPath.startsWith(page)
        )
        if (!matched) return
    }

    // 非表示持続時間のチェック（localStorage）
    if (settings.hideHours > 0) {
        const closedAt = localStorage.getItem(STORAGE_KEY)
        if (closedAt) {
            const elapsedHours = (Date.now() - parseInt(closedAt, 10)) / (1000 * 60 * 60)
            if (elapsedHours < settings.hideHours) return
        }
    }

    // CSS transform で画面外に隠れた状態で表示状態にする
    banner.style.display = 'block'

    // スクロール開始から2秒後にスライドイン
    window.addEventListener('scroll', () => {
        setTimeout(() => {
            banner.classList.add('is-visible')
            banner.setAttribute('aria-hidden', 'false')
        }, 2000)
    }, { once: true, passive: true })

    // 閉じるボタン：下方向へスライドアウト
    const closeBtn = banner.querySelector<HTMLButtonElement>('.js-floating-banner-close')
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            banner.classList.remove('is-visible')
            banner.setAttribute('aria-hidden', 'true')
            localStorage.setItem(STORAGE_KEY, String(Date.now()))
        })
    }
}
